import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';

export const StepTen = ({ statementslist }) => {
  const { values, setFieldValue } = useFormikContext();

  const handleCheckboxChange = (value) => {
    const set = new Set(values.statementList);
    if (set.has(value)) {
      set.delete(value);
    } else {
      set.add(value);
    }
    setFieldValue('statementList', Array.from(set));
  };

  return (
    <div className="w-full mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Relevant Statements</h6> */}
      <div className="mb-6 form-radio2-main">
        <p>
          <strong>Relevant Statements</strong>
          <span>Choose all statements that apply</span>
        </p>
        <div className="space-y-2">
          {statementslist && statementslist.length > 1 ? (
            statementslist?.map((ele, i) => {
              const id = `statementList_${i}`;
              return (
              <div className="flex gap-3 items-start form-check2 statements" key={i} >
                <Field
                  id={id}
                  className="mr-2"
                  type="checkbox"
                  name="statementList"
                  value={ele.value}
                  checked={values.statementList.includes(ele.value)}
                  onChange={() => handleCheckboxChange(ele.value)}
                />
                <label htmlFor={id}>{ele.text}</label>
              </div>
            )})
          ) : (
            <p>
              We can’t give you accurate advice based on the info provided.{' '}
              <b>Please go back and write a little more detail.</b> Thanks so much!
            </p>
          )}
          <ErrorMessage name="statementList" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
